import type { FC } from 'react';
import { withIncidents } from '../../components/incidents/with-incidents.js';
import { useSetTitle } from '../../hooks/use-title.js';
import { IncidentMapView } from './view.js';

const IncidentMap: FC = withIncidents((props) => {
  useSetTitle('Activity Map');
  return <IncidentMapView {...props} />;
});

export default IncidentMap;
